import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { environment } from 'environment';
import { FooterConstants } from 'src/app/common/constants/footer-constants';

@UntilDestroy()
@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  labels = FooterConstants;
  currentYear = new Date().getFullYear();
  companyName = this.labels.companyName;

  privacyUrl = environment.zpaxPrivacyPolicyEndPoint;
  termsUrl = environment.zpaxTermsEndPoint;
}